<template>
  <w-spoiler summary="Instrukcja wypełnienia tabeli w części D formularza">
    <div class="row form-group instruction-minimis">
      <div class="col-12">
        <table class="table-de-minimis page-size" border="1">
          <tr class="initial bg-white">
            <td class="text-center">
              <strong>Instrukcja wypełnienia tabeli w części D formularza</strong>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td class="padding-5 b-bottom">
              <p>
                Należy podać informacje o dotychczas otrzymanej pomocy, w odniesieniu do tych samych kosztów
                kwalifikujących się do objęcia pomocą, na pokrycie których udzielana będzie pomoc de minimis. Na
                przykład, jeżeli podmiot ubiegający się o pomoc de minimis otrzymał w przeszłości pomoc w związku z
                realizacją inwestycji, należy wykazać jedynie pomoc przeznaczoną na te same koszty kwalifikujące się do
                objęcia pomocą, na pokrycie których ma być udzielona pomoc de minimis.
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td class="padding-5 b-bottom">
              <p>
                <strong>1.</strong> <u>Dzień udzielenia pomocy</u> (kol. 1) - należy podać dzień udzielenia pomocy w
                rozumieniu art. 2 pkt 11 ustawy z dnia 30 kwietnia 2004 r. o postępowaniu w sprawach dotyczących pomocy
                publicznej.
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td class="padding-5 b-bottom">
              <p>
                <strong>2.</strong> <u>Podmiot udzielający pomocy</u> (kol. 2) - należy podać pełną nazwę i adres
                podmiotu, który udzielił pomocy. W przypadku gdy podmiot uzyskał pomoc na podstawie aktu normatywnego,
                który uzależnia nabycie prawa do otrzymania pomocy wyłącznie od spełnienia przesłanek w nim określonych,
                bez konieczności wydania decyzji albo zawarcia umowy, należy pozostawić to miejsce niewypełnione.
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td class="padding-5 b-bottom">
              <p><strong>3.</strong> <u>Podstawa prawna otrzymanej pomocy</u> (kol. 3a i 3b)</p>

              <p>
                <strong>Uwaga:</strong> istnieją następujące możliwości łączenia elementów tworzących podstawę prawną
                otrzymanej pomocy, które należy wpisać w poszczególnych kolumnach tabeli w sposób przedstawiony poniżej.
              </p>

              <table border="1">
                <tr>
                  <td class="text-center">
                    <strong>Podstawa prawna - informacje podstawowe</strong>
                  </td>

                  <td class="text-center">
                    <strong>Podstawa prawna - informacje szczegółowe</strong>
                  </td>
                </tr>

                <tr>
                  <td class="text-center">
                    <strong>3a</strong>
                  </td>

                  <td class="text-center">
                    <strong>3b</strong>
                  </td>
                </tr>

                <tr>
                  <td class="text-center">przepis ustawy</td>

                  <td class="text-center">brak*</td>
                </tr>

                <tr>
                  <td class="text-center">przepis ustawy</td>

                  <td class="text-center">przepis aktu wykonawczego</td>
                </tr>

                <tr>
                  <td class="text-center">przepis ustawy</td>

                  <td class="text-center">
                    <p>przepis aktu wykonawczego</p>

                    <p>decyzja/uchwała/umowa – symbol</p>
                  </td>
                </tr>

                <tr>
                  <td class="text-center">przepis ustawy</td>

                  <td class="text-center">decyzja/uchwała/umowa – symbol</td>
                </tr>
              </table>

              <small>
                * W przypadku braku aktu wykonawczego, decyzji, uchwały i umowy należy wpisać określenie „brak”.
              </small>

              <p class="mt-4">
                <strong>Kol. 3a</strong> Podstawa prawna - informacje podstawowe - należy podać w następującej
                kolejności: datę i tytuł oraz oznaczenie roku (numeru) i pozycji Dziennika Ustaw, w którym ustawa
                została opublikowana oraz oznaczenie przepisu ustawy będącego podstawą udzielenia pomocy (w kolejności:
                artykuł, ustęp, punkt, litera, tiret).
              </p>

              <p>
                <strong>Kol. 3b</strong> Podstawa prawna - informacje szczegółowe - jeżeli podstawą udzielenia pomocy
                był akt wykonawczy do ustawy, należy podać w następującej kolejności: nazwę organu wydającego akt, datę
                aktu i tytuł aktu oraz oznaczenie roku (numeru) i pozycji Dziennika Ustaw, w którym akt został
                opublikowany oraz przepis aktu wykonawczego będącego podstawą udzielenia pomocy (w kolejności: paragraf,
                ustęp, punkt, litera, tiret). Akt powinien być aktem wykonawczym do ustawy wskazanej w kol. 3a. W
                przypadku braku aktu wykonawczego będącego podstawą prawną udzielenia pomocy, należy wstawić określenie
                „brak”. Jeżeli podstawą udzielenia pomocy była decyzja, uchwała lub umowa, należy podać symbol
                określający ten akt; w przypadku decyzji - numer decyzji, w przypadku uchwały - numer uchwały, w
                przypadku umowy – numer, przedmiot oraz strony umowy. W przypadku braku decyzji, uchwały lub umowy
                będącej podstawą prawną udzielenia pomocy, należy wstawić określenie „brak”.
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td>
              <p>
                <strong>4.</strong> <u>Forma pomocy</u> (kol. 4) - należy podać kod oznaczający właściwą formę pomocy
                określony w załączniku nr 1 do rozporządzenia Rady Ministrów z dnia 7 sierpnia 2008 r. w sprawie
                sprawozdań o udzielonej pomocy publicznej, informacji o nieudzieleniu takiej pomocy oraz sprawozdań o
                zaległościach przedsiębiorców we wpłatach świadczeń należnych na rzecz sektora finansów publicznych (Dz.
                U. z 2024 r. poz. 161).
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td>
              <p>
                <strong>5.</strong> <u>Wartość otrzymanej pomocy publicznej lub pomocy de minimis</u> (kol. 5a i 5b) -
                należy podać: a) wartość nominalną pomocy (jako całkowitą wielkość środków finansowych będących podstawą
                do obliczania wielkości udzielonej pomocy, np. kwota udzielonej pożyczki lub kwota odroczonego podatku)
                oraz b) wartość brutto (jako ekwiwalent dotacji brutto obliczony zgodnie z rozporządzeniem Rady
                Ministrów wydanym na podstawie art. 11 ust. 2 ustawy z dnia 30 kwietnia 2004 r. o postępowaniu w
                sprawach dotyczących pomocy publicznej oraz właściwymi przepisami unijnymi).
              </p>
            </td>
          </tr>

          <tr class="initial bg-white">
            <td>
              <p>
                <strong>6.</strong> <u>Przeznaczenie pomocy publicznej</u> (kol. 6) - należy podać kod wskazujący
                przeznaczenie otrzymanej pomocy określony zgodnie z rozporządzeniem Rady Ministrów z dnia 7 sierpnia
                2008 r. w sprawie sprawozdań o udzielonej pomocy publicznej, informacji o nieudzieleniu takiej pomocy
                oraz sprawozdań o zaległościach przedsiębiorców we wpłatach świadczeń należnych na rzecz sektora
                finansów publicznych.
              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </w-spoiler>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Instrukcja wypełnienia tabeli w sekcji D formularza de minimis
// @Group formComponents
export default {
  components: {
    ...components
  }
};
</script>

<style>
.instruction-minimis strong {
  font-weight: bolder;
}
</style>
